<template>
    <AModal
        :visible="visible"
        :title="`List Konversi Level Produk: ${item.product_name}`"
        @cancel="handleModalCancel"
        :destroy-on-close="true"
        width="70%"
        :footer="null">

        <AForm
            v-if="state.isForm"
            ref="formRef"
            class="myform"
            :model="form"
            :rules="state.rules"
            @finish="handleOk"
            :wrapper-col="{ span: 14 }"
            :scroll-to-first-error="true">

            <!-- level -->
            <AFormItem
                label="Pilih Level"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="level"
                has-feedback>
                <FilterProgramLoyaltyLevelConversion
                    style="width:100%;"
                    :disabled="form.id"
                    :mode="null"
                    v-model:value="form.level"/>
            </AFormItem>

            <!-- entitas -->
            <AFormItem
                label="Pilih Entitas"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="entitas"
                has-feedback>
                <FilterProgramLoyaltyEntitasConversion
                    style="width:100%;"
                    :disabled="form.id"
                    v-model:level="form.level"
                    v-model:program="state.program_id"
                    v-model:value="form.entitas"/>
            </AFormItem>

            <!-- qty -->
            <AFormItem
                label="QTY"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="qty"
                has-feedback>
                <AInputNumber
                    style="width: 100%"
                    placeholder="qty"
                    type="number"
                    :min="1"
                    v-model:value="form.qty"/>
            </AFormItem>

            <!-- point -->
            <AFormItem
                label="Poin"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="point"
                has-feedback>
                <AInputNumber
                    style="width: 100%"
                    type="number"
                    :min="1"
                    placeholder="poin"
                    v-model:value="form.point"/>
            </AFormItem>

            <!-- tanggal -->
            <ARow class="form-row">
                <ACol :md="12" :sm="24">
                    <AFormItem
                        label="Tanggal Awal"
                        label-align="left"
                        :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }"
                        name="start_date"
                        has-feedback>
                        <ADatePicker
                            v-model:value="form.start_date"
                            :disabled-date="disabledStartDate"
                            format="DD MMMM YYYY"
                            value-format="YYYY-MM-DD"
                            style="width:100%"
                            placeholder="Pilih Tanggal"/>
                    </AFormItem>
                </ACol>
                <ACol :md="12" :sm="24">
                    <AFormItem
                        label="Tanggal Akhir"
                        label-align="left"
                        :label-col="{ sm: { span: 8 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 } }"
                        name="end_date"
                        has-feedback>
                        <ADatePicker
                            v-model:value="form.end_date"
                            :disabled-date="disabledEndDate"
                            format="DD MMMM YYYY"
                            value-format="YYYY-MM-DD"
                            style="width:100%"
                            placeholder="Pilih Tanggal"/>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- status -->
            <AFormItem
                label="Status"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="active"
                has-feedback>
                <ARadioGroup
                    v-model:value="form.active"
                    style="width:100%">
                    <ARadio :value="true">Aktif</ARadio>
                    <ARadio :value="false">Non Aktif</ARadio>
                </ARadioGroup>
            </AFormItem>

            <!-- submit -->
            <ARow class="form-row mt-2">
                <ACol :sm="4"/>
                <ACol :sm="20">
                    <ASpace>
                        <AButton
                            type="primary"
                            html-type="submit"
                            :loading="form.busy"
                            :disabled="form.busy">{{ 
                                form.id ? 'Perbarui' : 'Simpan'
                             }}</AButton>
                        <AButton
                            title="Batal"
                            @click="state.isForm = !state.isForm; form.reset()">Batal</AButton>
                    </ASpace>
                </ACol>
            </ARow>
        </AForm>
        <div
            v-else
            class="row justify-content-end">
            <div class="col-auto">
                <ASpace>
                    <ATooltip
                        title="Tambahkan">
                        <AButton
                            @click="state.isForm = !state.isForm"
                            type="primary">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                </ASpace>
            </div>
        </div>
        
        <AAlert
            v-if="errorMessage"
            type="error"
            class="mt-2"
            :message="errorMessage"
            banner
            closable
            @close="errorMessage = null"/>

        <div v-if="state.errors.length" class="mt-2">
            <AAlert
                v-for="(item, index) in state.errors"
                class="mb-2"
                type="error"
                :key="index"
                :message="item.message"
                banner
                closable
                @close="state.errors = []" />
        </div>

        <!-- list table -->
        <div class="table-responsive text-nowrap mt-4">
            <MdTable
                :columns="state.columns"
                :data-source="state.data"
                size="small"
                :row-class-name="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                :pagination="{
                    showSizeChanger: true,
                    pageSizeOptions: ['5', '10', '20', '30', '50', '75'],
                    showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} Hasil ${total} `,
                    total: state.meta.total,
                    pageSize: state.meta.per_page,
                    current: state.meta.page,
                }"
                @change="handleTableChange"
                :loading="state.isFetching">
                <template #action="{ record }">
                    <ASpace>
                        <ATooltip title="Edit">
                            <AButton
                                class="button"
                                size="small"
                                :disabled="!record.is_edit"
                                @click="btnEdit(record)">
                                <i class="fe fe-edit" />
                            </AButton>
                        </ATooltip>
                    </ASpace>
                </template>
            </MdTable>
        </div>
    </AModal>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import apiClient from '@/services/axios'
import { message } from 'ant-design-vue'
import FilterProgramLoyaltyEntitasConversion from '@/components/filter/FilterProgramLoyaltyEntitasConversion'
import FilterProgramLoyaltyLevelConversion from '@/components/filter/FilterProgramLoyaltyLevelConversion'
import Form from 'vform'
import moment from 'moment'
import { pickBy } from 'lodash'
import {
    hasRoles,
    ROLE_ADMIN_BK,
} from '@/helpers'

export default defineComponent({
    components: {
        FilterProgramLoyaltyEntitasConversion,
        FilterProgramLoyaltyLevelConversion,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
            }),
        },
    },
    emits: ['update:visible'],
    setup(props, { emit }) {
        const errorMessage = ref()
        const formRef = ref();

        const form = reactive(new Form({
            point_conversion_id: props.item.point_conversion_id,
            entitas: [],
            level: null,
            qty: null,
            point: null,
            start_date: null,
            end_date: null,
            active: false,
        }))

        const state = reactive({
            columns: [
                {
                    title: 'Nama Rule',
                    dataIndex: 'rule',
                },
                {
                    title: 'Produk',
                    dataIndex: 'product_name',
                },
                {
                    title: 'Level',
                    dataIndex: 'level',
                },
                {
                    title: 'Entitas',
                    dataIndex: 'entitas',
                },
                {
                    title: 'UOM Produk',
                    dataIndex: 'product_uom_name',
                },
                {
                    title: 'QTY',
                    dataIndex: 'qty',
                },
                {
                    title: 'Nilai',
                    dataIndex: 'point',
                },
                {
                    title: 'UOM Program',
                    dataIndex: 'point_uom_name',
                },
                {
                    title: 'Tanggal Mulai',
                    dataIndex: 'start_date',
                },
                {
                    title: 'Tanggal Akhir',
                    dataIndex: 'end_date',
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                },
                {
                    title: 'Tanggal Ditambahkan',
                    dataIndex: 'created_at',
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            endpoint: {
                current: `/api/loyalty-conversion-special`,
            },
            errors: [],
            data: [],
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            isFetching: false,
            params: {
                q: '',
                point_conversion_id: props.item.point_conversion_id,
                page: 1,
                "per-page": 10,
            },
            isForm: false,
            rules: {
                level: [
                    {
                        required: true,
                        message: "Pilih level tidak boleh kosong!",
                    },
                ],
                entitas: [
                    {
                        required: true,
                        message: "Pilih entitas tidak boleh kosong!",
                    },
                ],
                qty: [
                    {
                        required: true,
                        message: "Qty tidak boleh kosong!",
                    },
                ],
                point: [
                    {
                        required: true,
                        message: "Poin tidak boleh kosong!",
                    },
                ],
                start_date: [
                    {
                        required: true,
                        message: "Tanggal mulai tidak boleh kosong!",
                    },
                ],
                end_date: [
                    {
                        required: true,
                        message: "Tanggal akhir tidak boleh kosong!",
                    },
                ],
                active: [
                    {
                        required: true,
                        message: "Status tidak boleh kosong!",
                    },
                ],
            },
            program_id: props.item.parent.program_id,
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const handleTableChange = (page, filters, sorter) => {
            state.params.page = page.current
            state.params["per-page"] = page.pageSize

            fetchDataList()
        }

        const disabledStartDate = (current) => {
            return current && (current > moment(form.end_date) || current < moment(props.item.parent.start_date, 'YYYY-MM-DD'))
        }

        const disabledEndDate = (current) => {

            console.log("disable Date" + current)

            return current && (moment(form.start_date) >= current || current >= moment(props.item.parent.end_date, 'YYYY-MM-DD'))
        }

        const handleOk = async () => {
            // validation form
            await formRef.value.validate()
                .catch(() => { });

            let request = form.id
                ? form.put(`${state.endpoint.current}/${form.id}`)
                : form.post(state.endpoint.current)

            request.then(({ data }) => {
                    message.success(form.id ? 'Berhasil mengubah!' : 'Berhasil menambah!')

                    form.reset()
                    formRef.value.resetFields()
                    state.isForm = false
                    fetchDataList()
                })
                .catch(({ response: { status, statusText, data } }) => {
                    errorMessage.value = null
                    
                    if (status === 422) {
                        state.errors = data
                    }

                    if (status === 500) {
                        const message = data.message
                        if (Array.isArray(message)) {
                            state.errors = message
                        } else {
                            errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                        }
                    }
                })

        }

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint.current, {
                    params: pickBy(state.params),
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    items.forEach(item => {
                        item.rule = props.item.parent.rule
                        item.point_uom_name = props.item.parent.point_uom_name
                        item.product_uom_name = props.item.parent.product_uom_name
                    })

                    state.data = items
                    state.meta.page = _meta.currentPage
                    state.meta.per_page = _meta.perPage
                    state.meta.total = _meta.totalCount
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        const btnEdit = (item) => {
            state.isForm = true
            formRef.value?.resetFields()
            form.clear()

            form.id = item.id
            form.point_conversion_id = props.item.point_conversion_id
            form.level = item.level_id
            form.entitas = item.entitas_id
            form.qty = item.qty
            form.point = item.point
            form.start_date = item.start_date
            form.end_date = item.end_date
            form.active = item.active
        }

        onMounted(() => {
            fetchDataList()
        })

        return {
            fetchDataList,
            state,
            formRef,
            form,
            disabledStartDate,
            disabledEndDate,
            errorMessage,
            handleModalCancel,
            handleTableChange,
            handleOk,
            btnEdit,
            // only variable role
            hasRoles,
            ROLE_ADMIN_BK,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
